import { render } from "./DashboardVehicleTab.vue?vue&type=template&id=49c1da0d&scoped=true"
import script from "./DashboardVehicleTab.vue?vue&type=script&lang=js"
export * from "./DashboardVehicleTab.vue?vue&type=script&lang=js"

import "./DashboardVehicleTab.vue?vue&type=style&index=0&id=49c1da0d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49c1da0d"]])

export default __exports__